(function () {
  const DURATION = 350;
  const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  function initAccordions(scope) {
    const details = (scope || document).querySelectorAll('.product__accordion.accordion details');
    details.forEach(function (el) {
      if (el.dataset.accordionInit) return;
      el.dataset.accordionInit = 'true';

      const summary = el.querySelector('summary');
      const content = el.querySelector('.accordion__content');
      if (!summary || !content) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        // If currently animating, finish it
        if (el._animation) {
          el._animation.cancel();
          el._animation = null;
        }

        if (el.open) {
          // Closing
          const startHeight = el.offsetHeight + 'px';
          const endHeight = summary.offsetHeight + 'px';

          el._animation = el.animate(
            { height: [startHeight, endHeight] },
            { duration: DURATION, easing: EASING }
          );

          el._animation.onfinish = function () {
            el.open = false;
            el.style.height = '';
            el.style.overflow = '';
            el._animation = null;
          };

          el.style.overflow = 'hidden';
        } else {
          // Opening
          el.open = true;

          var startHeight = summary.offsetHeight + 'px';
          var endHeight = el.scrollHeight + 'px';

          el.style.overflow = 'hidden';

          el._animation = el.animate(
            { height: [startHeight, endHeight] },
            { duration: DURATION, easing: EASING }
          );

          el._animation.onfinish = function () {
            el.style.height = '';
            el.style.overflow = '';
            el._animation = null;
          };
        }
      });
    });
  }

  // Init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAccordions(); });
  } else {
    initAccordions();
  }

  // Re-init when Shopify sections are re-rendered (theme editor + AJAX)
  document.addEventListener('shopify:section:load', function (e) {
    initAccordions(e.target);
  });
})();
